export default {
    pageName: 'History',
    tab: {
        attendance: ' Attendance ',
        quota: 'Quota'
    },
    year: 'Year',
    header: {
        type: 'Type',
        quota: 'Quota'
    }
}
